module.exports = __webpack_public_path__ + "static/media/07_360.792d546d.jpeg";